import React, { useEffect, useState } from 'react'
import moment from 'moment'

import { getBookingURL } from '../utils/Utils'

type EventTicketButtonData = {
  eventType?: string | string[]
  entryUrl?: string
}

type EventTicketButtonProps = {
  data?: EventTicketButtonData
}

export type EventApiItem = {
  datum: string
  eventTyp: number
  identifier: string
  nameDe: string
  nameEn: string
  generalNameDe: string
  generalNameEn: string
  from: string
  to: string
  ticketAvailible: boolean
}

type EventDayGroup = {
  date: string
  events: EventApiItem[]
}

function EventTicketButton({ data }: EventTicketButtonProps) {
  const eventType: string | string[] = data?.eventType ?? []
  const entryUrl = data?.entryUrl ?? ''
  const [eventsByDate, setEventsByDate] = useState<EventDayGroup[]>([])
  const eventTypePath = Array.isArray(eventType)
    ? eventType.join(',')
    : eventType

  useEffect(() => {
    moment.locale(window.jsProps.lang)

    fetch(
      `https://api.miniatur-wunderland.de/v1/events/${moment().format('YYYY-MM-DD')}/next3/${eventTypePath}/`,
      { method: 'GET', mode: 'cors' },
    )
      .then((response) => response.json())
      .then((data: EventApiItem[]) => {
        // Group events by date
        const groupedEvents = data.reduce<EventDayGroup[]>((prev, next) => {
          let days = prev.find((e) => e.date === next.datum)
          if (!days) {
            days = { date: next.datum, events: [] }
            prev.push(days)
          }
          days.events.push(next)
          return prev
        }, [])

        setEventsByDate(groupedEvents)
      })
      .catch((e) => {
        console.warn(e)
      })
  }, [eventTypePath])

  if (eventsByDate.length === 0) {
    return null
  }

  return (
    <div className="EventTeaserCta">
      <div className="EventTeaserCta__Date">
        <strong>
          {moment(eventsByDate[0].date, 'YYYY-MM-DD').format(
            'dddd, D. MMMM YYYY',
          )}{' '}
        </strong>
        <span className="EventTeaserCta__StartsAt">
          - {window.jsProps.lang === 'de' ? 'ab' : ''}{' '}
          {eventsByDate[0].events[0].from}{' '}
          {window.jsProps.lang === 'de' ? 'Uhr' : ''}
        </span>
      </div>
      <div className="EventTeaserCta__Buttons">
        <a
          className="EventTeaserCta__ButtonCta Cta Cta--icon Cta--icon-ticket"
          href={getBookingURL(eventsByDate[0].date, true)}
          target="_blank"
          rel="noreferrer"
        >
          {window.jsProps.strings.bookTickets}
        </a>
        <a className="EventTeaserCta__ButtonMore" href={entryUrl}>
          {window.jsProps.strings.readMore}
        </a>
      </div>
    </div>
  )
}

export default EventTicketButton
